var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#app {\n  font-family: 'Asap', sans-serif;\n}\n.bimg {\n  background: url(" + escape(require("../../assets/fondo3.jpg")) + ") no-repeat center center fixed;\n  background-size: cover;\n}\n", ""]);

// exports
